import { render, staticRenderFns } from "./DeleteCommunityVenue.vue?vue&type=template&id=55d6b546"
import script from "./DeleteCommunityVenue.vue?vue&type=script&lang=js"
export * from "./DeleteCommunityVenue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports